/**
 * Determine if the current page has the `isFlutterApp` url param
 * @returns A boolean indicating if the current page has the `isFlutterApp` url param
 */
const hasFlutterAppUrlParam = (): boolean => {
  // If no searchParams provided, try to get from window (client-side only)
  if (typeof window !== 'undefined' && window?.location?.search) {
    const urlParams = new URLSearchParams(window.location.search)

    return Boolean(urlParams.get('isFlutterApp') === '1')
  }

  // Return false if we can't determine (server-side without searchParams parameter)
  return false
}

export {hasFlutterAppUrlParam}
